export default __webpack_public_path__ + "static/media/footermenu_sp.d6eadc71.png";